import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Box,
  Input,
  Table,
  TableCaption,
  Button,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  AlertDialog,
  useDisclosure,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import Cookie from "js-cookie";
import KotbillPrintModal from "./kotPrintModal";

const KotBillData = () => {
  const [data, setData] = useState([]);
  const token = Cookie.get("token");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100; // or any number you prefer

  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();
  const {
    isOpen: isPrintOpen,
    onOpen: onPrintOpen,
    onClose: onPrintClose,
  } = useDisclosure();
  const handlePrintModal = () => {
    onPrintOpen();
  };

  const customerId = localStorage.getItem("customerId");

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getKotBillDataByDateRange/${customerId}?startDate=${startDate}&endDate=${endDate}`,
      );
      setData(response.data);
      setFilteredData(response.data);
    } catch (error) {}
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  useEffect(() => {
    fetchData();
  }, [customerId, startDate, endDate]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
    filterData(searchTerm, event.target.value, endDate);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
    filterData(searchTerm, startDate, event.target.value);
  };

  const filterData = (term, start, end) => {
    let filtered = data.filter((order) => {
      const orderDate = new Date(order.createdAt).getTime();

      console.log(typeof order.tableNo, "tableNo");
      if (term && !order.tableNo.includes(term)) {
        return false;
      }

      return true;
    });

    setFilteredData(filtered);
  };
  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `https://api.rasoi.launchlysoftware.in/api/kotDelete/${customerId}/${deleteItemId}?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toast.success(response.data.message);
      setIsOpen(false);
      fetchData();
    } catch (error) {
      if (error.response.status === 403) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };
  const openModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };

  const handleReprint = (order) => {
    console.log("Reprinting Order:", order);

    const printWindow = window.open("", "", "height=600,width=800");
    printWindow.document.write(
      "<html><head><title>Reprint KOT</title></head><body>",
    );

    // Table info
    printWindow.document.write(`<h2>Reprint - Table: ${order.tableNo}</h2>`);
    printWindow.document.write(
      `<p><strong>Server:</strong> ${order.serverName}</p>`,
    );

    // KOT details
    printWindow.document.write(
      `<p><strong>KOT No:</strong> ${order.kotNo}</p>`,
    );
    printWindow.document.write(
      `<p><strong>Total:</strong> ₹${order.totalBilling}</p>`,
    );
    printWindow.document.write(
      `<p><strong>Time:</strong> ${new Date(order.createdAt).toLocaleString(
        "en-GB",
      )}</p>`,
    );

    // Item table
    printWindow.document.write(
      '<table border="1" cellspacing="0" cellpadding="5"><thead><tr><th>Item</th><th>Qty</th><th>Price</th></tr></thead><tbody>',
    );

    order.foodItem.forEach((item) => {
      printWindow.document.write(
        `<tr><td>${item.name}</td><td>${item.quantity}</td><td>${item.price}</td></tr>`,
      );
    });

    printWindow.document.write("</tbody></table>");
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <Box p={6} bg="gray.50" minH="90vh">
      <Box mb={6}>
        <Box display="flex" gap={4} flexWrap="wrap" alignItems="center">
          <Input
            flex="1"
            minW="250px"
            type="text"
            placeholder="Search by Table Number"
            value={searchTerm}
            onChange={handleSearchChange}
            bg="white"
          />
          <Input
            w="180px"
            type="date"
            placeholder="Start Date"
            value={startDate}
            onChange={handleStartDateChange}
            bg="white"
          />
          <Input
            w="180px"
            type="date"
            placeholder="End Date"
            value={endDate}
            onChange={handleEndDateChange}
            bg="white"
          />
          <Button colorScheme="teal" onClick={handlePrintModal}>
            Print
          </Button>
        </Box>
      </Box>
      <TableContainer
        width="full"
        bg="white"
        borderRadius="lg"
        boxShadow="md"
        maxH="calc(100vh - 250px)"
        overflowY="auto"
      >
        <Table size="sm" variant="striped" colorScheme="green">
          <TableCaption>KOT Bill Data</TableCaption>
          <Thead position="sticky" top={0} bg="green.500" zIndex={1}>
            <Tr>
              <Th color="white">Food Items</Th>
              <Th color="white">Table No</Th>
              <Th color="white">Server Name</Th>
              <Th color="white">KOT No</Th>
              <Th color="white">Total Bill</Th>
              <Th color="white">Created At</Th>
              <Th color="white">Reprint</Th>
              <Th color="white">Delete</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentItems.map((order, index) => (
              <Tr key={index}>
                <Td py={3}>
                  <Table
                    size="sm"
                    variant="simple"
                    bg="orange.50"
                    borderRadius="md"
                  >
                    <Thead>
                      <Tr>
                        <Th fontSize="xs">Food Item</Th>
                        <Th fontSize="xs">Quantity</Th>
                        <Th fontSize="xs">Price</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {order.foodItem.map((item, idx) => (
                        <Tr key={idx}>
                          <Td fontSize="sm">{item.name}</Td>
                          <Td fontSize="sm">{item.quantity}</Td>
                          <Td fontSize="sm">₹{item.price}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Td>
                <Td py={3}>{order.tableNo}</Td>
                <Td py={3}>{order.serverName}</Td>
                <Td py={3}>{order.kotNo}</Td>
                <Td py={3} fontWeight="semibold">
                  ₹{order.totalBilling}
                </Td>
                <Td py={3}>
                  {new Date(order.createdAt).toLocaleString("en-GB")}
                </Td>
                <Td py={3}>
                  <Button
                    colorScheme="blue"
                    size="sm"
                    onClick={() => handleReprint(order)}
                  >
                    Reprint
                  </Button>
                </Td>
                <Td py={3}>
                  <Button
                    colorScheme="red"
                    size="sm"
                    onClick={() => openModal(order._id)}
                  >
                    Delete
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <KotbillPrintModal
        isOpen={isPrintOpen}
        onOpen={onPrintOpen}
        onClose={onPrintClose}
        data={filteredData}
      />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt={6}
        gap={2}
      >
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
          size="sm"
          colorScheme="blue"
          variant="outline"
        >
          Previous
        </Button>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            size="sm"
            colorScheme="blue"
            onClick={() => handlePageChange(i + 1)}
            variant={currentPage === i + 1 ? "solid" : "outline"}
          >
            {i + 1}
          </Button>
        ))}
        <Button
          colorScheme="blue"
          size="sm"
          variant="outline"
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default KotBillData;
